import { UI } from "components"
import { Route, Routes as BrowserRoutes } from "react-router-dom"
import useChatwoot from "hooks/useChatwoot"
import useDistributor from "hooks/useDistributor"
import AtualizarDados from "pages/atualizar-dados"
import { useEffect, useState } from "react"
import { useQueryClient } from "@tanstack/react-query"
import { API } from "config"

import Home from "pages/home"
import Auth from "pages/auth"
import Recovery from "pages/recovery"
import Financial from "pages/financial"
import Orders from "pages/orders"
import Stock from "pages/stock"
import Shopping from "pages/shopping"
import Order from "pages/order"
import Buy from "pages/buy"
import Profile from "pages/profile"
import Store from "pages/store"
import Adjusts from "pages/adjusts"
import AnalyticsGeneral from "./pages/analytics/general";
import AnalyticsFinancial from "./pages/analytics/financial";
import AnalyticsBestSelling from "./pages/analytics/best-selling";
import AnalyticsClient from "./pages/analytics/client";

export default function Routes(){

    const token = localStorage.getItem('@token')

    if(!!token) return <PrivateRoutes />
    
    return <PublicRoutes />

}

const PrivateRoutes = () => {
    useChatwoot()
    const queryClient = useQueryClient()
    const { data: distributor, isLoading } = useDistributor()
    const [updateSkipped, setUpdateSkipped] = useState(false)

    if (isLoading) return null

    const needsUpdate = distributor?.update_data_at === null
    const overdue = distributor?.mandatory_update_overdue === true

    if (needsUpdate && (!updateSkipped || overdue)) {
        return (
            <AtualizarDados
                daysRemaining={distributor?.mandatory_update_days_remaining}
                overdue={overdue}
                onSkip={!overdue ? () => setUpdateSkipped(true) : undefined}
            />
        )
    }

    return(
    <UI.Layout>
        <BrowserRoutes>

            {/* Home */}
            <Route index element={<Home />} />

            {/* Financial */}
            <Route path="/financeiro" element={<Financial />} />

            {/* Analytics */}
            {/* SubRoutes */}
            <Route path="/relatorio/geral" element={<AnalyticsGeneral />} />
            <Route path="/relatorio/financeiro" element={<AnalyticsFinancial />} />
            <Route path="/relatorio/vendidos" element={<AnalyticsBestSelling />} />
            <Route path="/relatorio/clientes" element={<AnalyticsClient />} />

            {/* Stock */}
            <Route path="/estoque" element={<Stock />} />

            {/* Orders */}
            <Route path="/pedidos" element={<Orders />} />

            {/* Order */}
            <Route path="/pedidos/:id" element={<Order />} />

            {/* Shopping */}
            <Route path="/compras" element={<Shopping />} />

            {/* Buy */}
            <Route path="/compras/:id" element={<Buy />} />
    
            {/* Profile */}
            <Route path="perfil" element={<Profile />} />

            {/* Store */}
            <Route path="loja" element={<Store />} />

            {/* Adjusts */}
            <Route path="ajustes" element={<Adjusts />} />

        </BrowserRoutes>
    </UI.Layout>
    )
}

const PublicRoutes = () => {
    return(
    <BrowserRoutes>

        {/* Authenticate */}
        <Route index element={<Auth />} />

        {/* Recuperação de senha */}
        <Route path="/recuperacao" element={<Recovery />} />

        {/* Acesso remoto */}
        {/* <Route path="support/remote" element={<Remote />} /> */}
    </BrowserRoutes>
    )
}